<template>
    <div class="lottery-page" style="
      background: #FFFFFF;
      background-size: cover;
      padding-bottom: 6rem;
      position: relative;
    ">
        <NoticeBar
            class="col-lg-12 col-12 mx-auto notice-bar"
            scrollable
            :text="text"
            v-if="text"
        />
        <!-- <Sticky class="normal-box pt-3 px-2">
            <div style="background: #0D3B1A; border-radius: 5px;" class="col-12 mx-auto py-3">
                <div class="d-flex justify-content-between">
                  <div class="d-flex justify-content-between">
                      <div class="text-md" style="color: #F5F7F5;">
                            Balance :
                            {{
                                Number($store.state.amount).toLocaleString()
                            }} {{ $store.state.language === "en" ? "Ks" : "ကျပ်" }}
                      </div>
                      
                      <div class="text-md text-dark">
                        {{ $store.state.language === "en" ? "Bet Close" : "ထီပိတ်ချိန်" }} : {{ closeFormattedDate(threed.draw_date) }}, {{ threed.latest_bet }} PM
                      </div>
                  </div>
                    <div class="col-3 p-0">
                      <button class="btn mx-3" style="background: #E8B923; color: #0D3B1A;" @click="$router.push('/user/dream-books?type=3d')">
                      {{
                          $store.state.language === "en"
                              ? "Dream"
                              : "အိမ်မက်"
                      }}
                      </button>
                    </div>
                </div>
                <hr class="mt-2 mb-3">
                <div class="d-flex justify-content-between">
                    <div class="col-6 p-0">
                        <div class="form-group mb-0">
                                <input
                                    type="number"
                                    ref="amount"
                                    v-model="numberAmount"
                                    class="form-control amount"
                                    placeholder="100.00 MMK"
                                    style="height: 35px;"
                                />
                        </div>
                    </div>

                    <div class="d-flex">
                          <span class="px-2 my-auto py-1 number-reverse" :class="isReverse ? 'active' : ''" @click="isReverse = !isReverse">R</span>
                    </div>

                    <div class="col-4 p-0 pl-2">
                        <button class="btn btn-success" style="background: #E8B923; border: none; width: 100%; height: 35px; color: #0D3B1A;"  @click="preBet">
                            <div>
                                {{
                                    $store.state.language === "en"
                                        ? "Bet"
                                        : "ထိုးမည်"
                                }}
                            </div>
                        </button>
                    </div>

                </div>

                <div class="d-flex justify-content-between pt-3">
                    <div class="col-6 d-flex justify-content-start px-0">
                          <span class="text-white text-sm font-weight-600 mr-2" @click="openColorsModal()">{{ $store.state.language === "en" ? "Meaning of Color!" : "အရောင်များ၏ အဓိပ္ပာယ်။" }}</span>
                          <span class="badge badge-dark text-white" style="background: #145224"><i class="fa fa-info" @click="openColorsModal()"></i> </span>
                    </div>
                    <div class="col-6 d-flex justify-content-end px-0">
                      <i class="fa fa-redo my-auto text-lg" style="color: #E8B923" @click="removeHistory()"></i>
                      <span class="my-auto text-white text-sm font-weight-600 ml-2" @click="removeHistory()">{{ $store.state.language === "en" ? "All Clear!" : "အားလုံးရှင်း။" }}</span>
                    </div>
                </div>
            </div>
      </Sticky> -->

    <div class="normal-box pt-3 px-2 threed-bet-sticky">
      <div class="col-12 mx-auto py-3 threed-bet-panel">
          <div class="d-flex justify-content-between">
              <div class="text-md threed-bet-panel__text">
                    Balance :
                    {{
                        Number($store.state.amount).toLocaleString()
                    }} {{ $store.state.language === "en" ? "Ks" : "ကျပ်" }}
              </div>
              
              <div class="text-md threed-bet-panel__text">
                {{ $store.state.language === "en" ? "Bet Close" : "ထီပိတ်ချိန်" }} : {{ closeFormattedDate(threed.draw_date) }}, {{ threed.latest_bet }}
              </div>
          </div>
          <div class="mt-2 mb-3"></div>
          <div class="d-flex justify-content-between">
              
              <div class="col-5 p-0">
                  <button class="btn threed-bet-btn threed-bet-btn--primary" @click="preBet">
                      <div v-if="!isBet">
                          {{
                              $store.state.language === "en"
                                  ? "Bet"
                                  : "ထိုးမည်"
                          }}
                      </div>
                  </button>
              </div>
              <div class="col-7 p-0 pl-2">
                  <div class="form-group mb-0">
                          <input
                              type="number"
                              ref="amount"
                              v-model="numberAmount"
                              class="form-control amount threed-bet-input"
                              placeholder="Amount: at least 100 Ks"
                          />
                  </div>
              </div>
          </div>
          <div class="mt-2 mb-3"></div>
          
          <div class="d-flex justify-content-between">
              <div class="d-flex">
                    <span class="px-2 my-auto py-1 number-reverse" :class="isReverse ? 'active' : ''" @click="isReverse = !isReverse">R</span>
              </div>
              <div class="col-5 p-0">
                <button class="btn threed-bet-btn threed-bet-btn--secondary" @click="$router.push('/user/dream-books?type=3d')">
                        {{
                            $store.state.language === "en"
                                ? "Dream"
                                : "အိမ်မက်"
                        }}
                </button>
              </div>
              <div class="col-5 p-0">
                  <button class="btn threed-bet-btn threed-bet-btn--secondary" @click="showGroupBox">
                      {{ $store.state.language === "en" ? "Quick Bet" : "အမြန်ရွေးထိုးမည်။" }}
                  </button>
              </div>
          </div>
          <div class="d-flex justify-content-between pt-3">
              <div class="col-6 d-flex justify-content-start px-0">
                <span class="badge threed-info-badge mr-2"><i class="fa fa-info" @click="openColorsModal()"></i></span>
                    <span class="text-sm font-weight-600 pt-1 threed-bet-panel__link" @click="openColorsModal()">{{ $store.state.language === "en" ? "Meaning of Color!" : "အရောင်များ၏ အဓိပ္ပာယ်။" }}</span>
                    
              </div>
              <div class="col-6 d-flex justify-content-end px-0">
                <i class="fa fa-redo my-auto text-lg threed-bet-panel__link" @click="removeHistory()"></i>
                <span class="my-auto text-sm font-weight-600 ml-2 threed-bet-panel__link" @click="removeHistory()">{{ $store.state.language === "en" ? "All Clear!" : "အားလုံးရှင်း။" }}</span>
              </div>
          </div>
      </div>
    </div>

    <div class="number-paginate-grid mt-2 mx-2">
        <div class="number-paginate px-1 py-1" :class="tableData === 1 ? 'active' : ''" @click="tableData = 1">000 - 099</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 2 ? 'active' : ''" @click="tableData = 2">100 - 199</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 3 ? 'active' : ''" @click="tableData = 3">200 - 299</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 4 ? 'active' : ''" @click="tableData = 4">300 - 399</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 5 ? 'active' : ''" @click="tableData = 5">400 - 499</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 6 ? 'active' : ''" @click="tableData = 6">500 - 599</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 7 ? 'active' : ''" @click="tableData = 7">600 - 699</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 8 ? 'active' : ''" @click="tableData = 8">700 - 799</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 9 ? 'active' : ''" @click="tableData = 9">800 - 899</div>
        <div class="number-paginate px-1 py-1" :class="tableData === 10 ? 'active' : ''" @click="tableData = 10">900 - 999</div>
    </div>

        <div class="d-flex p-0 flex-wrap main-wrapper">
            <div class="col-12 px-1 boxes pb-5" style="margin-bottom: 5rem !important">
                <Table @numbers="getNumbers" :isTwod="false" :allNumbers="allNumbers" :tableData="tableData" :on-my-event="myEventSource"/>
            </div>
        </div>

        <div class="lottery-modal-host">
            <div
                class="modal fade"
                id="mobile-voucher"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
            >
                <div
                    class="modal-dialog modal-dialog-centered modal-sm"
                    role="document"
                >
                    <div class="modal-content">
                        <div
                            class="text-center modal-cross"
                            @click="closeModal"
                        >
                            X
                        </div>
                        <div class="modal-body p-0">
                            <PreviewVoucher
                                :datas="datas"
                                @remove="removeHistory"
                                :isTwod="false"
                                :threedDate="threed.draw_date"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="lottery-modal-host">
            <div
                class="modal fade lottery-group-modal"
                id="3d_group_box"
                tabindex="-1"
                role="dialog"
                aria-labelledby="3d-group-modal-title"
                aria-hidden="true"
            >
                <div
                    class="modal-dialog modal-dialog-centered modal-sm"
                    role="document"
                >
                    <div class="modal-content lottery-group-modal__content">
                        <button
                            type="button"
                            class="lottery-group-modal__close"
                            aria-label="Close"
                            @click="closeGroupBox"
                        >
                            ×
                        </button>
                        <div class="modal-body p-0">
                            <ThreedGroupBox @numbers="getGroupNumbers" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="lottery-modal-host">
            <div
                class="modal fade colors-legend-modal"
                id="colors-modal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="colors-modal-title"
                aria-hidden="true"
            >
                <div
                    class="modal-dialog modal-dialog-centered modal-sm"
                    role="document"
                >
                    <div class="modal-content colors-legend-modal__content">
                        <button
                            type="button"
                            class="colors-legend-modal__close"
                            aria-label="Close"
                            @click="closeModal"
                        >
                            ×
                        </button>
                        <div class="colors-legend-modal__header">
                              <h4 id="colors-modal-title" class="colors-legend-modal__title">
                                {{ $store.state.language === "en" ? "Meaning of Color" : "အရောင် အဓိပ္ပါယ်" }}
                              </h4>
                              <p class="colors-legend-modal__subtitle">
                                {{ $store.state.language === "en"
                                  ? "Numbers are closed when they reach 100%."
                                  : "100% ဖြစ်သောအခါ ထီနံပါတ်များကို ပိတ်ပါမည်။" }}
                              </p>
                            </div>
                        <div class="modal-body colors-legend-modal__body">
                            <ul class="colors-legend-modal__list">
                              <li class="colors-legend-modal__item">
                                  <span class="colors-legend-modal__swatch colors-legend-modal__swatch--green"></span>
                                  <span class="colors-legend-modal__label">50% အောက်</span>
                              </li>
                              <li class="colors-legend-modal__item">
                                  <span class="colors-legend-modal__swatch colors-legend-modal__swatch--yellow"></span>
                                  <span class="colors-legend-modal__label">50% မှ 75% အတွင်း</span>
                              </li>
                              <li class="colors-legend-modal__item">
                                  <span class="colors-legend-modal__swatch colors-legend-modal__swatch--red"></span>
                                  <span class="colors-legend-modal__label">90% အထက်</span>
                              </li>
                              <li class="colors-legend-modal__item">
                                  <span class="colors-legend-modal__swatch colors-legend-modal__swatch--gray"></span>
                                  <span class="colors-legend-modal__label">အပြည့် (100%)</span>
                              </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import { newEventSource } from 'vue-parent-emit';
import { NoticeBar, Dialog } from 'vant';
import PreviewVoucher from '../../components/PreviewVoucher.vue';
import Table from '../../components/Table.vue';
import ThreedGroupBox from '../../components/ThreedGroupBox.vue';
import NormalBox from '../../components/NormalBox.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    PreviewVoucher,
    ThreedGroupBox,
    NoticeBar,
    Table,
    NormalBox,
  },
  data() {
    return {
      tableData: 1,
      myEventSource: newEventSource(),
      text: '',
      datas: [],
      selected_data: {},
      isMobile: false,
      numberAmount: null,
      isReverse: false,
      threed: {},
      allNumbers: [],
      voucherLength: 0,
      isBet: false,
    };
  },
  methods: {
    openColorsModal() {
      $('#colors-modal').modal('show');
    },
    showGroupBox() {
      $('#3d_group_box').modal('show');
    },
    closeGroupBox() {
      $('#3d_group_box').modal('hide');
    },
    getGroupNumbers(value) {
      for (let i = 0; i < this.allNumbers.length; i += 1) {
        this.allNumbers[i].isSelect = false;
      }
      for (let i = 0; i < value.length; i += 1) {
        const idx = this.allNumbers.findIndex(
          (obj) => String(obj.number).padStart(3, '0') === String(value[i].number).padStart(3, '0'),
        );
        if (idx >= 0) {
          this.allNumbers[idx].isSelect = true;
        }
      }
      this.datas = Object.values(
        value.reduce((acc, item) => {
          if (!acc[item.number]) acc[item.number] = item;
          return acc;
        }, {}),
      ).map((item) => ({
        ...item,
        solo_amount: this.numberAmount,
        draw: this.threed.draw_date,
      }));
      $('#3d_group_box').modal('hide');
    },
    closeFormattedDate(draw) {
      return moment(draw).format('MMM Do');
    },
    ...mapActions(['fetchUser']),
    slipId() {
      return this.voucherLength;
    },
    async checkCurrentVouchers() {
      try {
        const res = await axios.post('/vouchers/check', {
          type: 'threed',
        },{
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
              });
        this.voucherLength = res.data.voucherLength;
      } catch (error) {
        console.log(error);
      }
    },
    getPermutations(str) {
      if (str.length <= 1) return [str];
      
      const permutations = [];
      
      for (let i = 0; i < str.length; i++) {
        const char = str[i];
        const remainingChars = str.slice(0, i) + str.slice(i + 1);
        for (const permutation of this.getPermutations(remainingChars)) {
          permutations.push(char + permutation);
        }
      }

      return permutations;
    },
    dialog(text) {
            Dialog.alert({
                message: text,
                confirmButtonText:
                    this.$store.state.language === "en"
                        ? "Go Back"
                        : "နောက်သို့ပြန်သွားမည်။",
            }).then(() => {
                // on close
            });
        },
    async preBet() {
    try {
      if (this.isBet) {
          return false;
      }
      if (this.voucherId === this.slipId()) {
          return false;
      }
      if (this.datas.length == 0) {
          const dataError = this.$store.state.language === "en"
                            ? "Please pick some numbers!"
                            : "နံပါတ်အချို့ ရွေးပေးပါ။";
          this.dialog(dataError);
          return false;
      }
      if (!this.numberAmount) {
          const dataError = this.$store.state.language === "en" ? 'Please enter amount' : 'ငွေပမာဏထည့်ပေးပါ။';
          this.dialog(dataError);
          return false;
      }
      if (this.numberAmount < 100) {
          this.errors.amount = this.$store.state.language === 'en'
          ? 'Please enter at least 100 MMK'
          : 'ငွေပမာဏအနည်းဆုံး ၁၀၀ ထည့်ပေးပါ။';

          const dataError = this.$store.state.language === "en" ? 'Please enter at least 100 MMK' : 'ငွေပမာဏအနည်းဆုံး ၁၀၀ ထည့်ပေးပါ။';
          this.dialog(dataError);
          return false;
      }
      
      if(this.isReverse){
        // Step 1: Generate permutations for numbers in selected data (datas)
        const allPermutations = this.datas.flatMap(item => {
          const numberStr = String(item.number).padStart(3, '0'); // Pad with leading zeros
          return this.getPermutations(numberStr).map(perm => ({
            ...item,
            number: perm // Use permutation as the new number
          }));
        });

        // Step 2: Filter allNumbers based on permutations
        const filteredFromAllNumbers = this.allNumbers.filter(item =>
          allPermutations.some(permItem => permItem.number === String(item.number).padStart(3, '0'))
        );

        // Step 3: Merge filtered data with selected data (datas)
        const combinedData = [
          ...this.datas,
          ...filteredFromAllNumbers
        ];

        // Step 4: Remove duplicates based on number
        this.datas = Array.from(new Map(combinedData.map(item => [item.number, item])).values());

        // Ensure numbers are handled as strings with consistent padding and ordering
        this.datas.forEach(item => {
          item.number = String(item.number).padStart(3, '0');
        });
      }

      this.datas = this.datas.map(item => ({
            ...item,          // Spread the existing properties of the object
            solo_amount: this.numberAmount,  // Add or update the `solo_amount` property
            draw: this.threed.draw_date
        }));
     
    $("#mobile-voucher").modal("show");
    } catch (error) {
        console.log(error);
    }
  },

  sendEvent() {
    this.myEventSource.emit();
  },

    closeModal() {
      $('#mobile-voucher').modal('hide');
      $('#colors-modal').modal('hide');
      $('#3d_group_box').modal('hide');
    },
    getNumbers(value) {
      this.datas = value;
      this.datas = this.datas.map(item => ({
            ...item,          // Spread the existing properties of the object
            solo_amount: this.numberAmount, // Add or update the `solo_amount` property
            draw: this.threed.draw_date
        }));
    },
    removeHistory() {
      this.datas = [];
      this.fetchClosedNumbers();
      $("#mobile-voucher").modal("hide");
      this.numberAmount = null;
      this.sendEvent();
      this.allNumbers = this.allNumbers.map(item => ({
        ...item,
        isSelect: false
      }));
    },
    async fetchClosedNumbers() {
      try {
        const res = await axios.get('/3d/get_closed_threed_numbers');
        this.text = res.data.data.length > 0
          ? `${
            this.$store.state.language === 'en'
              ? 'Closed number(s)'
              : 'ပိတ်ထားသော နံပါတ်များ'
          } : ${res.data.data.toString()}`
          : null;
      } catch (error) {
        console.log(error);
      }
    },
    async threeData() {
      try {
        const res = await axios.get('3d/data');
        this.threed = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedNumbers() {
      try {
        const res = await axios.post('/threed_numbers', {
          limit: 'all',
        });
       this.allNumbers = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    this.fetchClosedNumbers();
    this.fetchThreedNumbers();
    this.checkCurrentVouchers();
    this.threeData();
    // App shell is always phone-width (Index.vue col-lg-4), so use mobile UI on PC too
    this.isMobile = true;
    if (this.$auth.check()) {
      this.$store.commit(
        'setAmount',
        parseInt(this.$store.state.authUser.amount, 10),
      );
    }
  },
};
</script>
<style scoped>
/* CSS sticky stays inside the 520px app shell (Vant Sticky uses fixed and breaks out on PC) */
.threed-bet-sticky {
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #FFFFFF;
}

.threed-bet-panel {
  background: #FFFFFF !important;
  border: 1.5px solid rgba(13, 59, 26, 0.22);
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(8, 38, 18, 0.08);
}

.threed-bet-panel__text {
  color: #0D3B1A !important;
  font-weight: 600;
}

.threed-bet-panel__link {
  color: #0D3B1A !important;
  cursor: pointer;
}

.threed-bet-btn {
  width: 100%;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: none !important;
  font-weight: 700 !important;
  min-height: 32px;
}

.threed-bet-btn--primary {
  background: #0D3B1A !important;
  color: #FFFFFF !important;
}

.threed-bet-btn--secondary {
  background: #E8B923 !important;
  color: #0D3B1A !important;
}

.threed-bet-input {
  height: 32px !important;
  border-radius: 8px !important;
  border: 1.5px solid rgba(13, 59, 26, 0.35) !important;
  background: #FFFFFF !important;
  color: #1A2E1F !important;
}

.threed-info-badge {
  background: #0D3B1A !important;
  color: #FFFFFF !important;
  cursor: pointer;
}

.number-paginate-grid {
    width: calc(100% - 1rem);
    gap: 6px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}
.number-paginate{
    border: 1.5px solid rgba(13, 59, 26, 0.35);
    border-radius: 5px;
    color: #0D3B1A;
    background: #FFFFFF;
    text-align: center;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}
.number-paginate.active{
    background: #0D3B1A;
    color: #FFFFFF;
    border: 1.5px solid #0D3B1A;
}
.lottery-modal-host {
    position: absolute;
    width: 0;
    height: 0;
    overflow: visible;
    padding: 0;
    margin: 0;
    border: 0;
}
.modal-cross {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding-top: 3px;
    margin-left: auto;
    color: white;
    cursor: pointer;
    margin-right: -9px;
    margin-top: -9px;
    background: #0D3B1A;
}
.input-group {
    border: 1px solid rgba(13, 59, 26, 0.22);
}
.notice-bar {
    font-size: 20px;
    color: #0D3B1A;
    background: rgba(13, 59, 26, 0.08);
}
.boxes {
    margin-top: 6px;
    margin-bottom: 7px;
}
.main-wrapper {
    padding: 0px !important;
}

.number-reverse {
  color: #0D3B1A;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  border: 1.5px solid #0D3B1A;
  background: #FFFFFF;
}

.number-reverse.active {
  background: #0D3B1A;
  color: #FFFFFF;
}
</style>
